export default "__VITE_ASSET__D9VL7Rfb__"